import { useState } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from "react-i18next"

const AutoCompleteWrapper = ({
  onLoad,
  value,
  onChangeValue,
  inputValue,
  onInputValueChange,
}) => {
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation('common')

  const handleOpen = async () => {
    setOpen(true)
    setLoading(true)

    const { data } = await onLoad()
    setLoading(false)

    setOptions([...data])
  }

  const handleClose = () => {
    setOpen(false)
    setOptions([])
  }

  return (
    <Autocomplete
      size='small'
      fullWidth
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      value={value}
      onChange={(_, newValue) => {
        onChangeValue(newValue)
      }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        onInputValueChange(newInputValue)
      }}
      getOptionLabel={option => option.name}
      options={options}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={t('search_colaborator')}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress
                      color='inherit'
                      size={20}
                    />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  )
}

export default AutoCompleteWrapper
